import endpoint from 'src/store/modules/endpoint'
import {
  commonDate,
  digitGroup
} from 'src/helpers'
import {
  pricesTypeOptionsPPN
} from 'src/vars'

export const so = {
  main: {
    api: endpoint.state.so,
    export: endpoint.state.so,
    columns: [
      {
        name: 'soNo',
        label: 'No. Sales Order',
        align: 'left',
        field: row => {
          return `
          <div class="flex no-wrap gap-3">
            <a href="${row.status === 'DRAFT' ? '/so/draft/preview' : '/so/detail'}/${row.id}/${encodeURIComponent(row.so_no)}" class="goto-preview-page">
              <strong class="text-primary text-underline">${row.so_no}</strong>
            </a>
              ${
                row.so_no_replacement && !!row.so_no_replacement
                ? ` <img
                src="${require('src/assets/images/icons/repeat.svg')}"
                class="color-blue"
                alt="icon"
              >`
                : ''
              }

              ${
                row.negotiation_id && !!row.negotiation_id
                  ? '<div class="custom-badge-blue dense">Nego</div>'
                  : ''
              }
          </div>` +
          `<div class="text-grey-6" style="font-size: 12px">
            ${
              row.so_no_cust
              ? row.so_no_cust
              : '-'
            }
          </div>`
        },
        sortable: true
      },
      {
        name: 'soNoReplacement',
        field: row => {
          if (!row.so_no_replacement) return '-'
          return `
          <div>
            <a href="/so/detail/${row.so_replacement_id}/${encodeURIComponent(row.so_no_replacement)}" class="goto-preview-page">
              <strong class="text-primary text-underline">${row.so_no_replacement}</strong>
            </a>
          </div>`
        },
        label: 'SO Pengganti',
        align: 'left',
        sortable: true
      },
      {
        name: 'customer',
        field: row => {
          return `
            <div class="text-primary">
              <strong>${row.customer_name}<strong>
            </div>
            <div class="text-grey-6" style="font-size: 12px">
              ${
                {
                  PROJECT_OWNER: 'Pemilik Proyek',
                  ARCHITECT: 'Arsitek',
                  DEVELOPER: 'Developer',
                  CONTRACTOR: 'Kontraktor',
                  OTHER: 'Lainnya'
                }[row.company?.type] || 'Retail'
              }
            </div>
          `
        },
        label: 'Customer',
        align: 'left',
        rowClass: 'td-width-small'
      },
      {
        name: 'createdAt',
        field: 'created_at',
        label: 'Tanggal Pemesanan',
        commonDate: true,
        align: 'left',
        rowClass: 'td-width-medium'
      },
      {
        name: 'metode',
        field: row => {
          const CMS = `
            <div class="custom-badge-purple dense">
              <img
                src="${require('src/assets/images/icons/12x12-user-purple.svg')}"
                class="color-purple"
                alt="icon"
              >
              <span class="q-ml-xs">Manual</span>
            </div>
            ${
              row.action_author
                ? `<div class="text-base text-capitalize">
                    ${row.action_author}
                  </div>`
                : ''
            }
            `
          const website = `
            <div class="custom-badge-green dense">
              <img
                src="${require('src/assets/images/icons/12x12-laptop.svg')}"
                class="color-purple"
                alt="icon"
              >
              <span class="q-ml-xs">Website</span>
            </div>
            ${
              `<div class="text-base">
                ${row.is_upo ? 'uPO' : ''}
              </div>`
            }
            `
          return {
            ECOM: website,
            PMP: website
          }[row.origin] || CMS
        },
        label: 'Metode',
        align: 'left',
        sortable: true,
        rowClass: 'td-width-small'
      },
      {
        name: 'paymentType',
        field: row => {
          const borderColor = row.payment_type === 'TERMIN' ? 'border-termin' : 'border-tunai'

          if (!row.payment_type) return '-'

          return `
          <div class="flex gap-3 items-center">
            <img
              src="${row.payment_type === 'TERMIN' ? row?.image_payment : require('src/assets/images/icons/so/tunai-icon.svg')}"
              class="${borderColor}"
              width="24px"
              height="24px"
              alt=""
              style="
                  border-radius: 9999px;
                  object-fit: cover;
                "
            />
            <div>
              <div>
                ${
                  row.payment_type === 'TERMIN'
                  ? row.bnpl_name
                  : {
                    TRANSFER: 'Tunai',
                    VIRTUAL_ACCOUNT: 'Tunai',
                    DOKU: 'Tunai',
                    TERMIN: 'Tempo'
                  }[row.payment_type]
                }
              </div>
              <div class="small text-grey-6">
                ${
                  {
                    TRANSFER: 'Transfer Manual',
                    VIRTUAL_ACCOUNT: 'Virtual Account',
                    DOKU: 'Paylater',
                    TERMIN: row.termin_day && !!row.termin_day
                      ? row.termin_day + ' Hari'
                      : ''
                  }[row.payment_type]
                }
              </div>
            </div>
          </div>
          `
        },
        label: 'Jenis Pembayaran',
        align: 'left',
        sortable: true,
        rowClass: 'td-width-small'
      },
      {
        name: 'totalBuying',
        field: row => {
          let className = 'text-grey-6'
          let otherProduct = ''
          if (row.other_product === 0) className = 'hidden'
          else otherProduct = `+${row.other_product} lainnya`

          return row.product_name && !!row.product_name
            ? `
              <div>${row.product_name}</div>
              <div
                class="${className}"
                style="font-size: 12px"
              >
                ${otherProduct}
              </div>
              `
            : '-'
        },
        label: 'Jumlah Pembelian',
        align: 'left',
        rowClass: 'td-width-medium'
      },
      {
        name: 'total',
        field: row => !!row.total && parseFloat(row.total) !== 0
          ? `Rp ${digitGroup(parseFloat(row.total))}`
          : 'Rp 0',
        label: 'Nilai SO',
        align: 'right',
        rowClass: 'text-right text-no-wrap',
        sortable: true
      },
      {
        name: 'totalPriceDo',
        field: row => !!row.total_price_do && parseFloat(row.total_price_do) !== 0
          ? `Rp ${digitGroup(parseFloat(row.total_price_do))}`
          : 'Rp 0',
        label: 'Nilai DO',
        align: 'right',
        rowClass: 'text-right text-no-wrap',
        sortable: true
      },
      {
        name: 'totalPriceInv',
        field: row => !!row.total_price_inv && parseFloat(row.total_price_inv) !== 0
          ? `Rp ${digitGroup(parseFloat(row.total_price_inv))}`
          : 'Rp 0',
        label: 'Nilai Invoice',
        align: 'right',
        rowClass: 'text-right text-no-wrap',
        sortable: true
      },
      {
        name: 'status',
        field: row => {
          const badgeStyle = {
            UNPAID: 'red',
            PAID: 'green',
            PROCESSED: 'blue',
            SENT: 'blue',
            FINISHED: 'blue',
            CANCELED: 'red',
            DRAFT: 'purple'
          }
          if (!row?.status) return '-'
          return `
          <div role="alert" class="custom-badge-${badgeStyle[row?.status]} dense">
            ${row?.status_submission}
          </div>
        `
        },
        label: 'Status',
        align: 'left',
        sortable: true
      }
    ],

    data: []
  }
}

export const soTabReadyPO = {
  columns: [
    {
      name: 'soNo',
      label: 'No. Sales Order',
      align: 'left',
      field: row => {
        return `
      <div class="flex no-wrap gap-3">
        <a href="/so/detail/${row.id}/${encodeURIComponent(row.so_no)}" class="goto-preview-page">
          <strong class="text-primary text-underline">${row.so_no}</strong>
        </a>
          ${
            row.so_no_replacement && !!row.so_no_replacement
            ? ` <img
            src="${require('src/assets/images/icons/repeat.svg')}"
            class="color-blue"
            alt="icon"
          >`
            : ''
          }

          ${
            row.negotiation_id && !!row.negotiation_id
              ? '<div class="custom-badge-blue dense">Nego</div>'
              : ''
          }
      </div>` +
      `<div class="text-grey-6" style="font-size: 12px">
        ${
          row.so_no_cust
          ? row.so_no_cust
          : '-'
        }
      </div>`
      },
      sortable: true
    },
    {
      name: 'soNoReplacement',
      field: row => {
        if (!row.so_no_replacement) return '-'
        return `
      <div>
        <a href="/so/detail/${row.so_replacement_id}/${encodeURIComponent(row.so_no_replacement)}" class="goto-preview-page">
          <strong class="text-primary text-underline">${row.so_no_replacement}</strong>
        </a>
      </div>`
      },
      label: 'SO Pengganti',
      align: 'left',
      sortable: true
    },
    {
      name: 'customer',
      field: row => {
        return `
        <div class="text-primary">
          <strong>${row.customer_name}<strong>
        </div>
        <div class="text-grey-6" style="font-size: 12px">
          ${
            {
              PROJECT_OWNER: 'Pemilik Proyek',
              ARCHITECT: 'Arsitek',
              DEVELOPER: 'Developer',
              CONTRACTOR: 'Kontraktor',
              OTHER: 'Lainnya'
            }[row.company?.type] || 'Retail'
          }
        </div>
      `
      },
      label: 'Customer',
      align: 'left',
      rowClass: 'td-width-small'
    },
    {
      name: 'createdAt',
      field: 'created_at',
      label: 'Tanggal Pemesanan',
      commonDate: true,
      align: 'left',
      rowClass: 'td-width-medium'
    },
    {
      name: 'metode',
      field: row => {
        const CMS = `
        <div class="custom-badge-purple dense">
          <img
            src="${require('src/assets/images/icons/12x12-user-purple.svg')}"
            class="color-purple"
            alt="icon"
          >
          <span class="q-ml-xs">Manual</span>
        </div>
        ${
          row.action_author
            ? `<div class="text-base text-capitalize">
                ${row.action_author}
              </div>`
            : ''
        }
        `
        const website = `
        <div class="custom-badge-green dense">
          <img
            src="${require('src/assets/images/icons/12x12-laptop.svg')}"
            class="color-purple"
            alt="icon"
          >
          <span class="q-ml-xs">Website</span>
        </div>
        ${
          `<div class="text-base">
            ${row.is_upo ? 'uPO' : ''}
          </div>`
        }
        `
        return {
          ECOM: website,
          PMP: website
        }[row.origin] || CMS
      },
      label: 'Metode',
      align: 'left',
      sortable: true,
      rowClass: 'td-width-small'
    },
    {
      name: 'paymentType',
      field: row => {
        const borderColor = row.payment_type === 'TERMIN' ? 'border-termin' : 'border-tunai'

        if (!row.payment_type) return '-'

        return `
      <div class="flex gap-3 items-center">
        <img
          src="${row.payment_type === 'TERMIN' ? row?.image_payment : require('src/assets/images/icons/so/tunai-icon.svg')}"
          class="${borderColor}"
          width="24px"
          height="24px"
          alt=""
          style="
              border-radius: 9999px;
              object-fit: cover;
            "
        />
        <div>
          <div>
            ${
              {
                TRANSFER: 'Tunai',
                VIRTUAL_ACCOUNT: 'Tunai',
                DOKU: 'Tunai',
                TERMIN: 'Tempo'
              }[row.payment_type]
            }
          </div>
          <div class="small text-grey-6">
            ${
              {
                TRANSFER: 'Transfer Manual',
                VIRTUAL_ACCOUNT: 'Virtual Account',
                DOKU: 'Paylater',
                TERMIN: row.termin_day && !!row.termin_day
                  ? row.termin_day + ' Hari'
                  : ''
              }[row.payment_type]
            }
          </div>
        </div>
      </div>
      `
      },
      label: 'Jenis Pembayaran',
      align: 'left',
      sortable: true,
      rowClass: 'td-width-small'
    },
    {
      name: 'totalBuying',
      field: row => {
        let className = 'text-grey-6'
        let otherProduct = ''
        if (row.other_product === 0) className = 'hidden'
        else otherProduct = `+${row.other_product} lainnya`

        return row.product_name && !!row.product_name
          ? `
          <div>${row.product_name}</div>
          <div
            class="${className}"
            style="font-size: 12px"
          >
            ${otherProduct}
          </div>
          `
          : '-'
      },
      label: 'Jumlah Pembelian',
      align: 'left',
      rowClass: 'td-width-medium'
    },
    {
      name: 'total',
      field: row => !!row.total && parseFloat(row.total) !== 0
        ? `Rp ${digitGroup(parseFloat(row.total))}`
        : 'Rp 0',
      label: 'Nilai SO',
      align: 'right',
      rowClass: 'text-right text-no-wrap',
      sortable: true
    },
    {
      name: 'totalPriceDo',
      field: row => !!row.total_price_do && parseFloat(row.total_price_do) !== 0
        ? `Rp ${digitGroup(parseFloat(row.total_price_do))}`
        : 'Rp 0',
      label: 'Nilai DO',
      align: 'right',
      rowClass: 'text-right text-no-wrap',
      sortable: true
    },
    {
      name: 'totalPriceInv',
      field: row => !!row.total_price_inv && parseFloat(row.total_price_inv) !== 0
        ? `Rp ${digitGroup(parseFloat(row.total_price_inv))}`
        : 'Rp 0',
      label: 'Nilai Invoice',
      align: 'right',
      rowClass: 'text-right text-no-wrap',
      sortable: true
    }
  ]
}

export const productListTable = {
  main: {
    columns: [
      {
        name: 'name',
        label: 'Nama Produk',
        align: 'left'
      },
      {
        name: 'priceType',
        label: 'Jenis Harga',
        align: 'left'
      },
      {
        name: 'price',
        label: 'Harga Produk',
        align: 'left'
      },
      {
        name: 'qty',
        label: 'Jumlah',
        align: 'left'
      },
      {
        name: 'priceIncludeTax',
        label: 'Harga Satuan<br><small>Termasuk PPN</small>',
        align: 'right'
      },
      {
        name: 'priceExcludeTax',
        label: 'Harga Satuan<br><small>Diluar PPN</small>',
        align: 'right'
      },
      {
        name: 'priceTotal',
        label: 'Total Harga',
        align: 'left'
      },
      {
        name: 'action',
        label: 'Aksi',
        align: 'center'
      }
    ],
    rows: [],
    show: true,
    loading: false
  },

  period: {
    columns: [
      {
        name: 'sort',
        label: 'Urutan',
        align: 'left'
      },
      {
        name: 'shippingAt',
        label: 'Tanggal Tiba',
        sortable: true,
        align: 'left'
      },
      {
        name: 'periodQty',
        label: 'Jumlah Produk',
        sortable: true,
        align: 'left'
      },
      {
        name: 'priceTotal',
        label: 'Total Harga',
        sortable: true,
        align: 'left'
      },
      {
        name: 'shipmentMethod',
        label: 'Metode Pengiriman',
        sortable: true,
        align: 'left'
      },
      {
        name: 'action',
        label: 'Aksi',
        sortable: true,
        align: 'left'
      }
    ]
  },

  data: []
}

export const otherCostListTable = {
  main: {
    columns: [
      {
        name: 'coaNo',
        label: 'No. CoA',
        sortable: true,
        align: 'left'
      },
      {
        name: 'name',
        label: 'Nama',
        sortable: true,
        align: 'left'
      },
      {
        name: 'date',
        label: 'Tanggal',
        sortable: true,
        align: 'left'
      },
      {
        name: 'type',
        label: 'Jenis',
        sortable: true,
        align: 'left'
      },
      {
        name: 'price',
        label: 'Nominal',
        sortable: true,
        align: 'right'
      },
      {
        name: 'tax',
        label: 'Pajak',
        sortable: true,
        align: 'left'
      },
      {
        name: 'document',
        label: 'Dokumen Opsional',
        sortable: true,
        align: 'left'
      },
      {
        name: 'action',
        label: '',
        sortable: false,
        align: 'left'
      }
    ],
    rows: [],
    show: true,
    loading: false,
    visibleColumns: []
  }
}

export const diffrenceCostListTable = {
  main: {
    columns: [
      {
        name: 'name',
        label: 'Nama Produk',
        align: 'left'
      },
      {
        name: 'qty',
        label: 'Jumlah Diminta',
        align: 'right'
      },
      {
        name: 'qty_received',
        label: 'Jumlah Diterima',
        align: 'right'
      },
      {
        name: 'diffrence',
        label: 'Selisih',
        align: 'right'
      }
    ],
    rows: [],
    show: true,
    loading: false
  }
}

export const costTable = (type) => {
  return {
    columns: [
      {
        name: 'coaNo',
        field: 'coaNo',
        label: 'No. CoA',
        align: 'left',
        sortable: true
      },
      {
        name: 'shippingName',
        field: row => {
          return `
            <div>${row.shippingName}</div>
            ${row.file}
          `
        },
        label: {
          shipmentCost: 'Nama Pengiriman',
          otherIncome: 'Nama'
        }[type] || 'Nama Pengiriman',
        align: 'left',
        sortable: true
      },
      {
        name: 'date',
        field: row => {
          return commonDate({
            date: row.date
          })
        },
        label: 'Tanggal',
        align: 'left',
        sortable: true
      },
      {
        name: 'type',
        field: row => {
          return {
            DEBIT: `<div class="custom-badge-green small">
                Debit
              </div>`,
            CREDIT: `<div class="custom-badge-red small">
                Kredit
              </div>`
          }[row.type]
        },
        label: 'Jenis',
        align: 'left',
        sortable: true
      },
      {
        name: 'price',
        field: row => {
          return 'Rp ' + digitGroup(row.price)
        },
        label: 'Nominal',
        align: 'right',
        classes: 'text-right',
        sortable: true
      },
      {
        name: 'tax',
        field: 'tax',
        label: 'Pajak',
        align: 'left',
        sortable: true
      }
    ],

    data: [],

    visibleColumns () {
      return {
        shipmentCost: [
          'coaNo',
          'shippingName',
          'date',
          'price'
          // 'type',
          // 'tax'
        ],
        otherIncome: [
          'coaNo',
          'shippingName',
          'date',
          'price'
        ]
      }[type]
    }
  }
}

export const shipmentCostListTable = {
  main: {
    columns: [
      {
        name: 'coa',
        label: 'No. CoA',
        sortable: true,
        align: 'left'
      },
      {
        name: 'shippingCostName',
        label: 'Nama Pengiriman',
        sortable: true,
        align: 'left'
      },
      {
        name: 'date',
        label: 'Tanggal',
        sortable: true,
        align: 'left'
      },
      {
        name: 'type',
        label: 'Jenis',
        sortable: true,
        align: 'left'
      },
      {
        name: 'price',
        label: 'Nominal',
        sortable: true,
        align: 'left'
      },
      {
        name: 'tax',
        label: 'Pajak',
        sortable: true,
        align: 'left'
      },
      {
        name: 'action',
        label: '',
        sortable: false,
        align: 'left'
      }
    ],
    rows: [],
    show: true,
    loading: false,
    visibleColumns: []
  }
}

const setBelumDiatur = (row) => {
  return ['PROCESSED', 'SCHEDULED', 'DRIVER_ASSIGNED', 'ON_DELIVERY', 'CANCELED'].includes(row.status)
}
export const productTable = {
  main: {
    columns: [
      {
        name: 'product',
        field: row => {
          const img = row?.image
            ? row?.image
            : require('assets/images/image-not-found-small.jpg')
          return `
            <div class="flex items-center no-wrap gap-3">
              <img
                src="${img}"
                width="32px"
                height="32px"
                alt=""
                style="
                  border-radius: 5px;
                  border: solid 1px #ddd;
                  object-fit: cover;
                "
              />
              <div class="flex column">
                <div class="text-wrap">
                  ${row?.label}
                </div>
                ${
                  row.variant && !!row.variant.length
                    ? `<div class="text-capitalize text-grey-6">
                        <span>
                          ${row.variant.join(', ')}
                        </span>
                      </div>`
                    : ''
                }
              </div>
            </div>
          `
        },
        label: 'Produk',
        align: 'left',
        sortable: true
      },
      {
        name: 'shipping',
        field: row => {
          return `
            <div>
              ${row.shipmentType}
            </div>
            <div class="text-caption text-grey-6">
              ${
                row.shippingAt
                  ? commonDate({
                    date: row.shippingAt
                  })
                  : ''
                }
            </div>`
        },
        label: 'Pengiriman',
        align: 'left',
        sortable: true
      },
      {
        name: 'priceType',
        label: 'Jenis Harga',
        field: row => {
          return pricesTypeOptionsPPN
            ?.find(item => item.value === row.priceType)
            ?.label
        }
      },
      {
        name: 'priceIncludeTax',
        label: 'Harga Satuan<br><small class="text-caption text-grey-6">Termasuk PPN</small>',
        field: row => 'Rp ' + digitGroup(row.priceIncludeTax),
        align: 'right',
        classes: 'text-right'
      },
      {
        name: 'priceExcludeTax',
        label: 'Harga Satuan<br><small class="text-caption text-grey-6">Diluar PPN</small>',
        field: row => {
          return 'Rp ' + digitGroup(row.priceExcludeTax)
        },
        align: 'right',
        classes: 'text-right'
      },
      {
        name: 'jumlah',
        field: row => {
          return `
            <div>${digitGroup(row.qty)}</div>
            <div class="text-caption text-grey-6">
              ${row.unit}
            </div>
          `
        },
        label: 'Jumlah',
        align: 'right',
        classes: 'text-right',
        sortable: true
      },
      {
        name: 'discountValueExcludeTax',
        label: 'Diskon<br><small class="text-caption text-grey-6">Diluar PPN</small>',
        field: row => 'Rp ' + digitGroup(row.discountValueExcludeTax),
        classes: 'text-right'
      },
      {
        name: 'subTotalExcludeTax',
        label: 'Total<br><small class="text-caption text-grey-6">Diluar PPN</small>',
        field: row => 'Rp ' + digitGroup(row.subTotalExcludeTax),
        classes: 'text-right'
      },

      // -----------------
      //
      // -----------------
      {
        name: 'price',
        field: row => {
          const priceOri = row.price !== row.priceOri && !!row.priceOri
            ? `<del class="text-negative text-caption">
                Rp ${digitGroup(row.priceOri)}
              </del>`
            : ''
          return `
            <div>
              Rp ${digitGroup(row.price)}
            </div>
            ${priceOri}
          `
        },
        label: 'Harga',
        align: 'right',
        classes: 'text-right',
        sortable: true
      },
      {
        name: 'total',
        field: row => {
          return row.total
            ? `Rp ${digitGroup(row.total)}`
            : ''
        },
        label: 'Total Pembelian',
        align: 'right',
        classes: 'text-right',
        sortable: true
      },
      {
        name: 'deliveryAt',
        field: row => {
          return `
            <div>
            ${
                row.deliveryAt
                  ? commonDate({
                    date: row.deliveryAt
                  })
                  : ''
                }
                </div>
          `
        },
        label: 'Pengiriman',
        align: 'left',
        sortable: true
      },
      {
        name: 'qty',
        field: row => {
          return `
            <div>${row.qty}</div>
            <div class="small text-grey-6">${row.unit}</div>
          `
        },
        label: 'Jumlah Diminta',
        align: 'right',
        classes: 'text-right',
        sortable: true
      },
      {
        name: 'sentItem',
        field: row => {
          if (setBelumDiatur(row)) return 'Belum diatur'

          return `<div>${row.actualQty}</div>
            <div class="small text-grey-6">${row.unit}</div>`
        },
        label: 'Jumlah Terkirim',
        align: 'right',
        classes: 'text-right',
        sortable: true
      },
      {
        name: 'difference',
        field: row => {
          if (setBelumDiatur(row)) return 'Belum diatur'

          return `<div>${row.diffQty}</div>
            <div class="small text-grey-6">${row.unit}</div>`
        },
        label: 'Selisih',
        align: 'right',
        classes: row => {
          let classes = 'text-right'
          if (row.diffQty < 0) classes += ' bg-amber-1'
          return classes
        },
        sortable: true
      }
    ],

    data: []
  }
}
